module.exports = __webpack_public_path__ + "img/dp158_07.7ddc8361.jpg";